export default __webpack_public_path__ + "static/media/product-2.e628f974.webp";